<div class="representative-list-component-root">
  <div class="loading-container" *ngIf="isLoading">
    <mat-spinner [diameter]="60" class="spinner"></mat-spinner>
  </div>
  <div *ngFor="let item of generalizedRepresentativeList">
    <app-representative-item [expiredTip]="expiredTip"
                             [generalizedRepresentative]="item"
                             [representativeItemLabels]="labels"
                             (promote)="doPromote($event)"
                             (remove)="doRemove($event)"
                             (resendInvite)="doResendInvite($event)"
                             [canTamper]="canTamper">
    </app-representative-item>
  </div>
</div>
